import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useKidsPolicyDetailOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { calcAdultPriceAsTotalNum } = viewModel;

	const updateCalcAdultPriceAsTotalNum: (checked: boolean) => void = useCallback(
		(checked) => {
			const newCalcAdultPriceAsTotalNum = {
				...calcAdultPriceAsTotalNum,
			};

			newCalcAdultPriceAsTotalNum.value = checked;

			onSetViewModel([{ key: "calcAdultPriceAsTotalNum", value: newCalcAdultPriceAsTotalNum }]);
		},
		[calcAdultPriceAsTotalNum, onSetViewModel],
	);

	return {
		calcAdultPriceAsTotalNum,
		updateCalcAdultPriceAsTotalNum,
	};
};
